import {
  COMMON_END_POINT,
  ORGANIZATION_END_POINT,
} from '../constants/pathConstants';

const AuthEndpoints = {
  InitAuthEndpoint: `${COMMON_END_POINT}init`,
  SendVerificationEndpoint: `${COMMON_END_POINT}send-verification`,
  GetCustomTokenEndpoint: `${COMMON_END_POINT}custom-token`,
  PasskeyLoginOptionsEndpoint: `${COMMON_END_POINT}passkeys/login/options`,
  PasskeyLoginVerifyEndpoint: `${COMMON_END_POINT}passkeys/login/verify`,
  PasskeyRegisterOptionsEndpoint: `${COMMON_END_POINT}passkeys/register/options`,
  PasskeyRegisterVerifyEndpoint: `${COMMON_END_POINT}passkeys/register/verify`,
  PasskeysEndpoint: `${COMMON_END_POINT}passkeys`,
  PasskeyCredentialEndpoint: (credentialId: string) =>
    `${COMMON_END_POINT}passkeys/${credentialId}`,
  EmailVerificationEndpoint: (email: string) =>
    `${COMMON_END_POINT}${email}/status`,
  CreatePasswordEndpoint: `${COMMON_END_POINT}signup`,
  ResetPasswordEmailStatusEndpoint: `${COMMON_END_POINT}reset-password`,
  CreateNewPasswordEndpoint: `${COMMON_END_POINT}new-password`,
  verifyOTP: `${COMMON_END_POINT}verify-otp`,
  CheckUserInOrgEndpoint: (orgId: string, email: string) =>
    `${ORGANIZATION_END_POINT}${orgId}/users/${email}/status`,
  setCookiesEndpoint: `${COMMON_END_POINT}tokens`,
  logoutEndpoint: `${COMMON_END_POINT}logout`,
  verifyLoginEndpoint: `${COMMON_END_POINT}verify-login`,
};

export default AuthEndpoints;
